import { useEffect, useEffectEvent } from 'react';

/**
 * useDisplayClock - the display's animation loop (plan map-display, Track C).
 *
 * While `active`, calls `onFrame(now)` once a frame (`requestAnimationFrame`,
 * `now` in ms) and nothing else; it stops the moment `active` turns false or
 * the component goes. Nothing runs when nothing moves, so a still map costs
 * no frames at all. Motion is the caller's: a screen that holds still simply
 * never asks for the clock.
 *
 * @param {boolean} active
 * @param {(now: number) => void} onFrame - the latest one is called; it need not be stable
 */
export default function useDisplayClock(active, onFrame) {
  const frame = useEffectEvent(onFrame);
  useEffect(() => {
    if (!active) return undefined;
    let id = window.requestAnimationFrame(function tick(now) {
      frame(now);
      id = window.requestAnimationFrame(tick);
    });
    return () => window.cancelAnimationFrame(id);
  }, [active]);
}
